// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Planes de trabajo — control global de tareas sobre el parque.
   Prefijo \`wp-\`. Solo tokens del tema: nada de colores en duro, para que
   funcione igual en los skins claros y oscuros. */

/* ── Alcance: chips de tipo y lista de elementos ────────────────────────── */

.wp-chip {
  padding: 5px 11px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  font: inherit;
  font-size: 0.8rem;
  cursor: pointer;
}

.wp-chip:hover { border-color: var(--accent); color: var(--accent); }

.wp-chip.is-on {
  border-color: var(--accent);
  background: rgba(var(--accent-rgb), 0.12);
  color: var(--accent-l, var(--accent));
  font-weight: 600;
}

.wp-target-list {
  max-height: 240px;
  overflow: auto;
  border: 1px solid var(--border);
  border-radius: 9px;
  padding: 6px;
  background: var(--bg-surface, var(--slate-50));
}

/* El diálogo de alcance lleva chips + lista: no puede crecer sin freno. */
.wp-alcance-dialog {
  max-height: 88vh;
  overflow: auto;
}

.wp-target-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 0.82rem;
  cursor: pointer;
}

.wp-target-row:hover { background: var(--slate-100); }
.wp-target-name { color: var(--text-primary); font-weight: 500; }
.wp-target-meta { color: var(--text-muted); font-size: 0.76rem; margin-left: auto; }

/* ── Pantalla completa del plan ─────────────────────────────────────────── */

.wp-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: var(--bg-app, var(--bg-card));
}

.wp-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 10px 18px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-card);
}

.wp-topbar-left,
.wp-topbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.wp-miga {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.84rem;
  color: var(--text-muted);
}

.wp-miga strong { color: var(--text-primary); font-weight: 600; }
.wp-miga-sep { opacity: 0.5; }

.wp-content {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 16px 18px 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wp-plan-desc {
  margin: 0;
  font-size: 0.86rem;
  color: var(--text-secondary);
  max-width: 90ch;
}

.wp-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.wp-toolbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.wp-filter { max-width: 320px; }

/* Condiciones guardadas del plan: portátiles, fecha de compra… */
.wp-filter-note {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 0.78rem;
  color: var(--text-muted);
}

.wp-filter-note-label {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.wp-filter-chip {
  padding: 2px 9px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
}

/* Constructor de condiciones del alcance */
.wp-conditions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 8px;
}

.wp-condition-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.wp-condition-row .list-input {
  flex: 1 1;
  min-width: 0;
}

.wp-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border-radius: 9px;
  border: 1px solid var(--red-600, #dc2626);
  background: color-mix(in srgb, var(--red-600, #dc2626) 10%, transparent);
  color: var(--red-700, #b91c1c);
  font-size: 0.84rem;
}

.wp-alert svg { width: 18px; height: 18px; flex: none; }

.wp-th-inner {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.wp-th-actions {
  display: inline-flex;
  align-items: center;
  gap: 1px;
}

/* Enlace al procedimiento del paso */
.wp-th-doc {
  display: inline-flex;
  align-items: center;
  color: var(--accent);
}

.wp-th-doc svg { width: 14px; height: 14px; }

/* Documentación del paso en el diálogo de alta/edición */
.wp-doc-picker {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.wp-doc-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  color: var(--accent);
  margin-bottom: 8px;
}

.wp-doc-link svg { width: 14px; height: 14px; }

.wp-doc-create {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.wp-doc-create .list-input { flex: 1 1; min-width: 0; }

/* Códigos propuestos antes de crear (editables) */
.wp-code-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 6px;
  max-height: 180px;
  overflow: auto;
  margin-bottom: 8px;
}

.wp-th-kind {
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  font-size: 0.68rem;
  color: var(--text-muted);
}

.wp-cell-who {
  font-size: 0.68rem;
  color: var(--text-secondary);
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wp-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.wp-progress-bar {
  flex: 1 1;
  height: 6px;
  border-radius: 999px;
  background: var(--slate-100);
  overflow: hidden;
}

.wp-progress-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--accent);
  transition: width 0.35s ease;
}

.wp-progress-fill.is-done { background: var(--green-600, #16a34a); }

.wp-progress-text {
  font-size: 0.78rem;
  font-variant-numeric: tabular-nums;
  color: var(--text-secondary);
  white-space: nowrap;
}

/* ── Detalle ────────────────────────────────────────────────────────────── */

.wp-detail {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.wp-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}

.wp-summary-card {
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
}

.wp-summary-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.wp-summary-value {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
  line-height: 1.25;
}

.wp-summary-hint { font-size: 0.75rem; color: var(--text-muted); }

/* Botón con texto dentro del resumen (los \`list-action-btn\` son solo icono). */
.wp-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  font: inherit;
  font-size: 0.82rem;
  cursor: pointer;
  white-space: nowrap;
}

.wp-btn:hover { border-color: var(--accent); color: var(--accent); }
.wp-btn:disabled { opacity: 0.6; cursor: default; border-color: var(--border); color: var(--text-secondary); }
.wp-btn svg { width: 16px; height: 16px; flex: none; }

/* Matriz equipos × pasos */
.wp-matrix {
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: auto;
  background: var(--bg-card);
  max-height: 60vh;
}

.wp-matrix table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: 0.82rem;
}

.wp-matrix th,
.wp-matrix td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
}

.wp-matrix thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--bg-surface, var(--slate-50));
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: normal;
  min-width: 168px;
  vertical-align: top;
}

.wp-matrix tbody tr:hover td { background: var(--slate-50); }

.wp-matrix .wp-sticky-col {
  position: sticky;
  left: 0;
  z-index: 1;
  background: var(--bg-card);
}
.wp-matrix thead .wp-sticky-col { z-index: 3; background: var(--bg-surface, var(--slate-50)); }

.wp-device-name { font-weight: 600; color: var(--text-primary); }
.wp-device-meta { font-size: 0.74rem; color: var(--text-muted); }

/* Celda de estado */
.wp-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  padding: 2px 6px;
  border-radius: 7px;
  cursor: pointer;
  color: var(--text-muted);
  font: inherit;
}

.wp-cell:hover { background: var(--slate-100); }
.wp-cell:disabled { cursor: default; opacity: 0.75; }

.wp-cell svg { width: 16px; height: 16px; flex: none; }

.wp-cell--done { color: var(--green-600, #16a34a); }
.wp-cell--failed { color: var(--red-600, #dc2626); }
.wp-cell--running { color: var(--accent); }
.wp-cell--skipped { color: var(--text-muted); }
.wp-cell--pending { color: var(--text-muted); }

.wp-cell-date {
  font-size: 0.7rem;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

/* Leyenda */
.wp-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 0.76rem;
  color: var(--text-secondary);
}

.wp-legend span { display: inline-flex; align-items: center; gap: 5px; }
.wp-legend svg { width: 14px; height: 14px; }

/* ── Plantillas de alta ─────────────────────────────────────────────────── */

.wp-template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.wp-template {
  position: relative;
  text-align: left;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-card);
  transition: border-color 0.15s ease, transform 0.15s ease;
}

.wp-template:hover { border-color: var(--accent); transform: translateY(-1px); }
.wp-template.is-selected { border-color: var(--accent); background: rgba(var(--accent-rgb), 0.08); }

.wp-template-body {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.wp-template-actions {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.wp-template:hover .wp-template-actions { opacity: 1; }

.wp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: var(--bg-surface, var(--slate-50));
  color: var(--text-secondary);
  cursor: pointer;
}

.wp-icon-btn:hover { border-color: var(--accent); color: var(--accent); }
.wp-icon-btn svg { width: 14px; height: 14px; }

.wp-tag {
  margin-left: 6px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 0.62rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: var(--slate-100);
  color: var(--text-muted);
  font-weight: 600;
}

.wp-template-title { font-weight: 600; color: var(--text-primary); font-size: 0.9rem; }
.wp-template-desc { font-size: 0.78rem; color: var(--text-muted); margin-top: 3px; }

/* Pasos en la ficha del equipo */
.wp-ci-plan {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 10px 12px;
  background: var(--bg-card);
}

.wp-ci-plan + .wp-ci-plan { margin-top: 8px; }

.wp-ci-plan-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.wp-ci-plan-title { font-weight: 600; font-size: 0.88rem; color: var(--text-primary); }

.wp-ci-step {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 0.82rem;
  color: var(--text-secondary);
}

.wp-ci-step svg { width: 15px; height: 15px; flex: none; }

.wp-ci-step-doc {
  display: inline-flex;
  align-items: center;
  color: var(--accent);
}

.wp-ci-step-doc svg { width: 13px; height: 13px; }

.wp-ci-step-obs {
  font-size: 0.72rem;
  color: var(--text-muted);
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}

@media (prefers-reduced-motion: reduce) {
  .wp-progress-fill,
  .wp-template { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/WorkPlans.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD,8EAA8E;;AAE9E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB,2BAA2B,EAAE,oBAAoB,EAAE;;AAEpE;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uBAAuB,4BAA4B,EAAE;AACrD,kBAAkB,0BAA0B,EAAE,gBAAgB,EAAE;AAChE,kBAAkB,wBAAwB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;;AAEnF,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,kBAAkB,0BAA0B,EAAE,gBAAgB,EAAE;AAChE,eAAe,YAAY,EAAE;;AAE7B;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,aAAa,gBAAgB,EAAE;;AAE/B,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,wEAAwE;EACxE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;;AAEvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,iBAAiB,WAAW,EAAE,YAAY,EAAE;;AAE5C,yDAAyD;AACzD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,6BAA6B,SAAO,EAAE,YAAY,EAAE;;AAEpD,kDAAkD;AAClD;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,4BAA4B,qCAAqC,EAAE;;AAEnE;EACE,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE;;AAEjE,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB,2BAA2B,EAAE,oBAAoB,EAAE;AACnE,mBAAmB,YAAY,EAAE,eAAe,EAAE,2BAA2B,EAAE,4BAA4B,EAAE;AAC7G,cAAc,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;;AAErD,2BAA2B;AAC3B;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,8CAA8C;EAC9C,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B,2BAA2B,EAAE;;AAE5D;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,0BAA0B;AAC5B;AACA,kCAAkC,UAAU,EAAE,8CAA8C,EAAE;;AAE9F,kBAAkB,gBAAgB,EAAE,0BAA0B,EAAE;AAChE,kBAAkB,kBAAkB,EAAE,wBAAwB,EAAE;;AAEhE,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,aAAa;AACf;;AAEA,iBAAiB,4BAA4B,EAAE;AAC/C,oBAAoB,eAAe,EAAE,aAAa,EAAE;;AAEpD,eAAe,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;;AAEtD,iBAAiB,gCAAgC,EAAE;AACnD,mBAAmB,8BAA8B,EAAE;AACnD,oBAAoB,oBAAoB,EAAE;AAC1C,oBAAoB,wBAAwB,EAAE;AAC9C,oBAAoB,wBAAwB,EAAE;;AAE9C;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACvE,iBAAiB,WAAW,EAAE,YAAY,EAAE;;AAE5C,8EAA8E;;AAE9E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA,qBAAqB,2BAA2B,EAAE,2BAA2B,EAAE;AAC/E,2BAA2B,2BAA2B,EAAE,yCAAyC,EAAE;;AAEnG;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;EACV,8BAA8B;AAChC;;AAEA,0CAA0C,UAAU,EAAE;;AAEtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,8CAA8C;EAC9C,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,qBAAqB,2BAA2B,EAAE,oBAAoB,EAAE;AACxE,mBAAmB,WAAW,EAAE,YAAY,EAAE;;AAE9C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,qBAAqB,gBAAgB,EAAE,0BAA0B,EAAE,iBAAiB,EAAE;AACtF,oBAAoB,kBAAkB,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAEnF,iCAAiC;AACjC;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,4BAA4B,eAAe,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,oBAAoB,gBAAgB,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;;AAEtF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,kBAAkB,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;;AAEzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,sBAAsB,WAAW,EAAE,YAAY,EAAE;;AAEjD;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE;iBACe,gBAAgB,EAAE;AACnC","sourcesContent":["/* Planes de trabajo — control global de tareas sobre el parque.\r\n   Prefijo `wp-`. Solo tokens del tema: nada de colores en duro, para que\r\n   funcione igual en los skins claros y oscuros. */\r\n\r\n/* ── Alcance: chips de tipo y lista de elementos ────────────────────────── */\r\n\r\n.wp-chip {\r\n  padding: 5px 11px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  font: inherit;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.wp-chip:hover { border-color: var(--accent); color: var(--accent); }\r\n\r\n.wp-chip.is-on {\r\n  border-color: var(--accent);\r\n  background: rgba(var(--accent-rgb), 0.12);\r\n  color: var(--accent-l, var(--accent));\r\n  font-weight: 600;\r\n}\r\n\r\n.wp-target-list {\r\n  max-height: 240px;\r\n  overflow: auto;\r\n  border: 1px solid var(--border);\r\n  border-radius: 9px;\r\n  padding: 6px;\r\n  background: var(--bg-surface, var(--slate-50));\r\n}\r\n\r\n/* El diálogo de alcance lleva chips + lista: no puede crecer sin freno. */\r\n.wp-alcance-dialog {\r\n  max-height: 88vh;\r\n  overflow: auto;\r\n}\r\n\r\n.wp-target-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  font-size: 0.82rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.wp-target-row:hover { background: var(--slate-100); }\r\n.wp-target-name { color: var(--text-primary); font-weight: 500; }\r\n.wp-target-meta { color: var(--text-muted); font-size: 0.76rem; margin-left: auto; }\r\n\r\n/* ── Pantalla completa del plan ─────────────────────────────────────────── */\r\n\r\n.wp-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  min-height: 0;\r\n  background: var(--bg-app, var(--bg-card));\r\n}\r\n\r\n.wp-topbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n  padding: 10px 18px;\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n}\r\n\r\n.wp-topbar-left,\r\n.wp-topbar-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wp-miga {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.84rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wp-miga strong { color: var(--text-primary); font-weight: 600; }\r\n.wp-miga-sep { opacity: 0.5; }\r\n\r\n.wp-content {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  padding: 16px 18px 28px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.wp-plan-desc {\r\n  margin: 0;\r\n  font-size: 0.86rem;\r\n  color: var(--text-secondary);\r\n  max-width: 90ch;\r\n}\r\n\r\n.wp-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wp-toolbar-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.wp-filter { max-width: 320px; }\r\n\r\n/* Condiciones guardadas del plan: portátiles, fecha de compra… */\r\n.wp-filter-note {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wp-filter-note-label {\r\n  font-size: 0.68rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.wp-filter-chip {\r\n  padding: 2px 9px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Constructor de condiciones del alcance */\r\n.wp-conditions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.wp-condition-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.wp-condition-row .list-input {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.wp-alert {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 9px 12px;\r\n  border-radius: 9px;\r\n  border: 1px solid var(--red-600, #dc2626);\r\n  background: color-mix(in srgb, var(--red-600, #dc2626) 10%, transparent);\r\n  color: var(--red-700, #b91c1c);\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.wp-alert svg { width: 18px; height: 18px; flex: none; }\r\n\r\n.wp-th-inner {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.wp-th-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 1px;\r\n}\r\n\r\n/* Enlace al procedimiento del paso */\r\n.wp-th-doc {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  color: var(--accent);\r\n}\r\n\r\n.wp-th-doc svg { width: 14px; height: 14px; }\r\n\r\n/* Documentación del paso en el diálogo de alta/edición */\r\n.wp-doc-picker {\r\n  margin-top: 12px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.wp-doc-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 0.78rem;\r\n  color: var(--accent);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.wp-doc-link svg { width: 14px; height: 14px; }\r\n\r\n.wp-doc-create {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.wp-doc-create .list-input { flex: 1; min-width: 0; }\r\n\r\n/* Códigos propuestos antes de crear (editables) */\r\n.wp-code-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n  gap: 6px;\r\n  max-height: 180px;\r\n  overflow: auto;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.wp-th-kind {\r\n  font-weight: 400;\r\n  text-transform: none;\r\n  letter-spacing: 0;\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wp-cell-who {\r\n  font-size: 0.68rem;\r\n  color: var(--text-secondary);\r\n  max-width: 90px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wp-progress {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 120px;\r\n}\r\n\r\n.wp-progress-bar {\r\n  flex: 1;\r\n  height: 6px;\r\n  border-radius: 999px;\r\n  background: var(--slate-100);\r\n  overflow: hidden;\r\n}\r\n\r\n.wp-progress-fill {\r\n  height: 100%;\r\n  border-radius: 999px;\r\n  background: var(--accent);\r\n  transition: width 0.35s ease;\r\n}\r\n\r\n.wp-progress-fill.is-done { background: var(--green-600, #16a34a); }\r\n\r\n.wp-progress-text {\r\n  font-size: 0.78rem;\r\n  font-variant-numeric: tabular-nums;\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Detalle ────────────────────────────────────────────────────────────── */\r\n\r\n.wp-detail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.wp-summary {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.wp-summary-card {\r\n  padding: 12px 14px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.wp-summary-label {\r\n  font-size: 0.72rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.wp-summary-value {\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  font-variant-numeric: tabular-nums;\r\n  line-height: 1.25;\r\n}\r\n\r\n.wp-summary-hint { font-size: 0.75rem; color: var(--text-muted); }\r\n\r\n/* Botón con texto dentro del resumen (los `list-action-btn` son solo icono). */\r\n.wp-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-secondary);\r\n  font: inherit;\r\n  font-size: 0.82rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wp-btn:hover { border-color: var(--accent); color: var(--accent); }\r\n.wp-btn:disabled { opacity: 0.6; cursor: default; border-color: var(--border); color: var(--text-secondary); }\r\n.wp-btn svg { width: 16px; height: 16px; flex: none; }\r\n\r\n/* Matriz equipos × pasos */\r\n.wp-matrix {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  overflow: auto;\r\n  background: var(--bg-card);\r\n  max-height: 60vh;\r\n}\r\n\r\n.wp-matrix table {\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  width: 100%;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.wp-matrix th,\r\n.wp-matrix td {\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid var(--border);\r\n  text-align: left;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n}\r\n\r\n.wp-matrix thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n  background: var(--bg-surface, var(--slate-50));\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n  font-size: 0.75rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  white-space: normal;\r\n  min-width: 168px;\r\n  vertical-align: top;\r\n}\r\n\r\n.wp-matrix tbody tr:hover td { background: var(--slate-50); }\r\n\r\n.wp-matrix .wp-sticky-col {\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 1;\r\n  background: var(--bg-card);\r\n}\r\n.wp-matrix thead .wp-sticky-col { z-index: 3; background: var(--bg-surface, var(--slate-50)); }\r\n\r\n.wp-device-name { font-weight: 600; color: var(--text-primary); }\r\n.wp-device-meta { font-size: 0.74rem; color: var(--text-muted); }\r\n\r\n/* Celda de estado */\r\n.wp-cell {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 2px 6px;\r\n  border-radius: 7px;\r\n  cursor: pointer;\r\n  color: var(--text-muted);\r\n  font: inherit;\r\n}\r\n\r\n.wp-cell:hover { background: var(--slate-100); }\r\n.wp-cell:disabled { cursor: default; opacity: 0.75; }\r\n\r\n.wp-cell svg { width: 16px; height: 16px; flex: none; }\r\n\r\n.wp-cell--done { color: var(--green-600, #16a34a); }\r\n.wp-cell--failed { color: var(--red-600, #dc2626); }\r\n.wp-cell--running { color: var(--accent); }\r\n.wp-cell--skipped { color: var(--text-muted); }\r\n.wp-cell--pending { color: var(--text-muted); }\r\n\r\n.wp-cell-date {\r\n  font-size: 0.7rem;\r\n  color: var(--text-muted);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* Leyenda */\r\n.wp-legend {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 14px;\r\n  font-size: 0.76rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.wp-legend span { display: inline-flex; align-items: center; gap: 5px; }\r\n.wp-legend svg { width: 14px; height: 14px; }\r\n\r\n/* ── Plantillas de alta ─────────────────────────────────────────────────── */\r\n\r\n.wp-template-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.wp-template {\r\n  position: relative;\r\n  text-align: left;\r\n  padding: 0;\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  background: var(--bg-card);\r\n  transition: border-color 0.15s ease, transform 0.15s ease;\r\n}\r\n\r\n.wp-template:hover { border-color: var(--accent); transform: translateY(-1px); }\r\n.wp-template.is-selected { border-color: var(--accent); background: rgba(var(--accent-rgb), 0.08); }\r\n\r\n.wp-template-body {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 12px 14px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: inherit;\r\n  font: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\n.wp-template-actions {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 6px;\r\n  display: flex;\r\n  gap: 2px;\r\n  opacity: 0;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n.wp-template:hover .wp-template-actions { opacity: 1; }\r\n\r\n.wp-icon-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  background: var(--bg-surface, var(--slate-50));\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.wp-icon-btn:hover { border-color: var(--accent); color: var(--accent); }\r\n.wp-icon-btn svg { width: 14px; height: 14px; }\r\n\r\n.wp-tag {\r\n  margin-left: 6px;\r\n  padding: 1px 6px;\r\n  border-radius: 999px;\r\n  font-size: 0.62rem;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  background: var(--slate-100);\r\n  color: var(--text-muted);\r\n  font-weight: 600;\r\n}\r\n\r\n.wp-template-title { font-weight: 600; color: var(--text-primary); font-size: 0.9rem; }\r\n.wp-template-desc { font-size: 0.78rem; color: var(--text-muted); margin-top: 3px; }\r\n\r\n/* Pasos en la ficha del equipo */\r\n.wp-ci-plan {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n  background: var(--bg-card);\r\n}\r\n\r\n.wp-ci-plan + .wp-ci-plan { margin-top: 8px; }\r\n\r\n.wp-ci-plan-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.wp-ci-plan-title { font-weight: 600; font-size: 0.88rem; color: var(--text-primary); }\r\n\r\n.wp-ci-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 0;\r\n  font-size: 0.82rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.wp-ci-step svg { width: 15px; height: 15px; flex: none; }\r\n\r\n.wp-ci-step-doc {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  color: var(--accent);\r\n}\r\n\r\n.wp-ci-step-doc svg { width: 13px; height: 13px; }\r\n\r\n.wp-ci-step-obs {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  margin-left: auto;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .wp-progress-fill,\r\n  .wp-template { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
